<script>
	import { Router } from "@roxi/routify";
	import { routes } from "../.routify/routes";
  	import { SvelteToast } from "@zerodevx/svelte-toast";
	const options = {}
</script>

<SvelteToast {options} />
<Router {routes}/>

<style global lang="postcss">
	@tailwind base;
  	@tailwind components;
  	@tailwind utilities;

	body, main {
		padding: 0;
		@apply min-h-full min-w-full;
	}

	input {
		@apply mt-0;
		@apply border-2 rounded-md shadow-sm font-thin pt-5 pb-1 pl-2 w-full;
	}
	
	.error-label {
		@apply text-red-500 mt-1;
	}

	.input {
		position: relative;
		display: inline-block;
	}
	
	.input .error-text {
		@apply absolute invisible text-center rounded-md font-thin text-gray-200 min-w-max left-1/2 -translate-x-1/2 pt-1 pb-2 px-2;
		background-color: #3a3a3a;
		z-index: 1;
		bottom: 100%;
	}

	.input:hover .error-text, input:focus .error-text {
		@apply visible;
	}

	.tooltip-div {
		position: relative;
		display: inline-block;
	}

	.tooltip-div .tooltip {
		@apply absolute invisible text-center rounded-md font-thin text-gray-200 min-w-max left-1/2 -translate-x-1/2 pt-1 pb-2 px-2;
		background-color: #3a3a3a;
		z-index: 1;
		bottom: 100%;
	}

	.tooltip-div:hover .tooltip, .tooltip-div:focus + .tooltip {
		@apply visible;
	}

	.card {
		@apply rounded-md shadow-lg bg-white;
	}
</style>